/* tslint:disable */
/* eslint-disable */
/**
 * Hisselab.PersonalScoring
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface CustomListEntity
 */
export interface CustomListEntity {
    /**
     * 
     * @type {string}
     * @memberof CustomListEntity
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomListEntity
     */
    'accountId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomListEntity
     */
    'listName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomListEntity
     */
    'createDateTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomListEntity
     */
    'updateDateTime'?: string;
    /**
     * 
     * @type {Array<Fields>}
     * @memberof CustomListEntity
     */
    'feilds'?: Array<Fields> | null;
    /**
     * 
     * @type {string}
     * @memberof CustomListEntity
     */
    'selectedIndexId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomListEntity
     */
    'selectedWatchlistId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CustomListEntity
     */
    'isIndustrial'?: boolean;
}
/**
 * 
 * @export
 * @interface Fields
 */
export interface Fields {
    /**
     * 
     * @type {string}
     * @memberof Fields
     */
    'dataId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Fields
     */
    'weight'?: number;
}
/**
 * 
 * @export
 * @interface SaveRequest
 */
export interface SaveRequest {
    /**
     * 
     * @type {string}
     * @memberof SaveRequest
     */
    'listName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveRequest
     */
    'selectedIndexId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveRequest
     */
    'selectedWatchlistId'?: string | null;
    /**
     * 
     * @type {Array<Fields>}
     * @memberof SaveRequest
     */
    'feilds'?: Array<Fields> | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveRequest
     */
    'isIndustrial'?: boolean;
}
/**
 * 
 * @export
 * @interface ScoreFieldDatas
 */
export interface ScoreFieldDatas {
    /**
     * 
     * @type {string}
     * @memberof ScoreFieldDatas
     */
    'code'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ScoreFieldDatas
     */
    'percent'?: number;
}
/**
 * 
 * @export
 * @interface ScoreFieldValues
 */
export interface ScoreFieldValues {
    /**
     * 
     * @type {string}
     * @memberof ScoreFieldValues
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ScoreFieldValues
     */
    'value'?: string | null;
}
/**
 * 
 * @export
 * @interface ScoringDataRequest
 */
export interface ScoringDataRequest {
    /**
     * 
     * @type {string}
     * @memberof ScoringDataRequest
     */
    'indexEntityId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ScoringDataRequest
     */
    'watchlistId'?: string | null;
    /**
     * 
     * @type {Array<ScoreFieldDatas>}
     * @memberof ScoringDataRequest
     */
    'scoreFields'?: Array<ScoreFieldDatas> | null;
}
/**
 * 
 * @export
 * @interface ScoringDataResponce
 */
export interface ScoringDataResponce {
    /**
     * 
     * @type {Array<ScoringDataValues>}
     * @memberof ScoringDataResponce
     */
    'data'?: Array<ScoringDataValues> | null;
}
/**
 * 
 * @export
 * @interface ScoringDataValues
 */
export interface ScoringDataValues {
    /**
     * 
     * @type {string}
     * @memberof ScoringDataValues
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ScoringDataValues
     */
    'uniqueCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ScoringDataValues
     */
    'entityId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ScoringDataValues
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ScoringDataValues
     */
    'flag'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ScoringDataValues
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof ScoringDataValues
     */
    'score'?: number;
}
/**
 * 
 * @export
 * @interface ScroreFieldResponce
 */
export interface ScroreFieldResponce {
    /**
     * 
     * @type {string}
     * @memberof ScroreFieldResponce
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ScroreFieldResponce
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface StateResponse
 */
export interface StateResponse {
    /**
     * 
     * @type {string}
     * @memberof StateResponse
     */
    'status'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof StateResponse
     */
    'error'?: string | null;
}
/**
 * 
 * @export
 * @interface SystemFilterResponse
 */
export interface SystemFilterResponse {
    /**
     * 
     * @type {string}
     * @memberof SystemFilterResponse
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SystemFilterResponse
     */
    'nameEng'?: string | null;
    /**
     * 
     * @type {Array<ScoreFieldValues>}
     * @memberof SystemFilterResponse
     */
    'scoreFields'?: Array<ScoreFieldValues> | null;
}
/**
 * 
 * @export
 * @interface UpdateRequest
 */
export interface UpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateRequest
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateRequest
     */
    'selectedIndexId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateRequest
     */
    'selectedWatchlistId'?: string | null;
    /**
     * 
     * @type {Array<Fields>}
     * @memberof UpdateRequest
     */
    'feilds'?: Array<Fields> | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateRequest
     */
    'isIndustrial'?: boolean;
}

/**
 * PersonalScoringApi - axios parameter creator
 * @export
 */
export const PersonalScoringApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [listName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPersonalscoringAddpagecustomlistPost: async (identityToken: string, listName?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('apiPersonalscoringAddpagecustomlistPost', 'identityToken', identityToken)
            const localVarPath = `/api/personalscoring/addpagecustomlist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (listName !== undefined) {
                localVarQueryParameter['ListName'] = listName;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPersonalscoringDeletepagecustomlistPost: async (identityToken: string, id?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('apiPersonalscoringDeletepagecustomlistPost', 'identityToken', identityToken)
            const localVarPath = `/api/personalscoring/deletepagecustomlist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['Id'] = id;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPersonalscoringPagecustomlistesPost: async (identityToken: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('apiPersonalscoringPagecustomlistesPost', 'identityToken', identityToken)
            const localVarPath = `/api/personalscoring/pagecustomlistes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [id] 
         * @param {string} [newListName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPersonalscoringRenamepagecustomlistPost: async (identityToken: string, id?: string, newListName?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('apiPersonalscoringRenamepagecustomlistPost', 'identityToken', identityToken)
            const localVarPath = `/api/personalscoring/renamepagecustomlist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['Id'] = id;
            }

            if (newListName !== undefined) {
                localVarQueryParameter['NewListName'] = newListName;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {SaveRequest} [saveRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPersonalscoringSaveaspagecustomlistPost: async (identityToken: string, saveRequest?: SaveRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('apiPersonalscoringSaveaspagecustomlistPost', 'identityToken', identityToken)
            const localVarPath = `/api/personalscoring/saveaspagecustomlist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPersonalscoringScorefieldsPost: async (identityToken: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('apiPersonalscoringScorefieldsPost', 'identityToken', identityToken)
            const localVarPath = `/api/personalscoring/scorefields`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {ScoringDataRequest} [scoringDataRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPersonalscoringScoringdataPost: async (identityToken: string, scoringDataRequest?: ScoringDataRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('apiPersonalscoringScoringdataPost', 'identityToken', identityToken)
            const localVarPath = `/api/personalscoring/scoringdata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(scoringDataRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPersonalscoringSystemfiltersPost: async (identityToken: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('apiPersonalscoringSystemfiltersPost', 'identityToken', identityToken)
            const localVarPath = `/api/personalscoring/systemfilters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {UpdateRequest} [updateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPersonalscoringUpdatepagecustomlistPost: async (identityToken: string, updateRequest?: UpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('apiPersonalscoringUpdatepagecustomlistPost', 'identityToken', identityToken)
            const localVarPath = `/api/personalscoring/updatepagecustomlist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PersonalScoringApi - functional programming interface
 * @export
 */
export const PersonalScoringApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PersonalScoringApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [listName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPersonalscoringAddpagecustomlistPost(identityToken: string, listName?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPersonalscoringAddpagecustomlistPost(identityToken, listName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPersonalscoringDeletepagecustomlistPost(identityToken: string, id?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPersonalscoringDeletepagecustomlistPost(identityToken, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPersonalscoringPagecustomlistesPost(identityToken: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CustomListEntity>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPersonalscoringPagecustomlistesPost(identityToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [id] 
         * @param {string} [newListName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPersonalscoringRenamepagecustomlistPost(identityToken: string, id?: string, newListName?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPersonalscoringRenamepagecustomlistPost(identityToken, id, newListName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {SaveRequest} [saveRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPersonalscoringSaveaspagecustomlistPost(identityToken: string, saveRequest?: SaveRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPersonalscoringSaveaspagecustomlistPost(identityToken, saveRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPersonalscoringScorefieldsPost(identityToken: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ScroreFieldResponce>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPersonalscoringScorefieldsPost(identityToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {ScoringDataRequest} [scoringDataRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPersonalscoringScoringdataPost(identityToken: string, scoringDataRequest?: ScoringDataRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScoringDataResponce>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPersonalscoringScoringdataPost(identityToken, scoringDataRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPersonalscoringSystemfiltersPost(identityToken: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SystemFilterResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPersonalscoringSystemfiltersPost(identityToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {UpdateRequest} [updateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPersonalscoringUpdatepagecustomlistPost(identityToken: string, updateRequest?: UpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPersonalscoringUpdatepagecustomlistPost(identityToken, updateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PersonalScoringApi - factory interface
 * @export
 */
export const PersonalScoringApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PersonalScoringApiFp(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [listName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPersonalscoringAddpagecustomlistPost(identityToken: string, listName?: string, options?: any): AxiosPromise<StateResponse> {
            return localVarFp.apiPersonalscoringAddpagecustomlistPost(identityToken, listName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPersonalscoringDeletepagecustomlistPost(identityToken: string, id?: string, options?: any): AxiosPromise<StateResponse> {
            return localVarFp.apiPersonalscoringDeletepagecustomlistPost(identityToken, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPersonalscoringPagecustomlistesPost(identityToken: string, options?: any): AxiosPromise<Array<CustomListEntity>> {
            return localVarFp.apiPersonalscoringPagecustomlistesPost(identityToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [id] 
         * @param {string} [newListName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPersonalscoringRenamepagecustomlistPost(identityToken: string, id?: string, newListName?: string, options?: any): AxiosPromise<StateResponse> {
            return localVarFp.apiPersonalscoringRenamepagecustomlistPost(identityToken, id, newListName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {SaveRequest} [saveRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPersonalscoringSaveaspagecustomlistPost(identityToken: string, saveRequest?: SaveRequest, options?: any): AxiosPromise<StateResponse> {
            return localVarFp.apiPersonalscoringSaveaspagecustomlistPost(identityToken, saveRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPersonalscoringScorefieldsPost(identityToken: string, options?: any): AxiosPromise<Array<ScroreFieldResponce>> {
            return localVarFp.apiPersonalscoringScorefieldsPost(identityToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {ScoringDataRequest} [scoringDataRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPersonalscoringScoringdataPost(identityToken: string, scoringDataRequest?: ScoringDataRequest, options?: any): AxiosPromise<ScoringDataResponce> {
            return localVarFp.apiPersonalscoringScoringdataPost(identityToken, scoringDataRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPersonalscoringSystemfiltersPost(identityToken: string, options?: any): AxiosPromise<Array<SystemFilterResponse>> {
            return localVarFp.apiPersonalscoringSystemfiltersPost(identityToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {UpdateRequest} [updateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPersonalscoringUpdatepagecustomlistPost(identityToken: string, updateRequest?: UpdateRequest, options?: any): AxiosPromise<StateResponse> {
            return localVarFp.apiPersonalscoringUpdatepagecustomlistPost(identityToken, updateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PersonalScoringApi - object-oriented interface
 * @export
 * @class PersonalScoringApi
 * @extends {BaseAPI}
 */
export class PersonalScoringApi extends BaseAPI {
    /**
     * 
     * @param {string} identityToken 
     * @param {string} [listName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalScoringApi
     */
    public apiPersonalscoringAddpagecustomlistPost(identityToken: string, listName?: string, options?: AxiosRequestConfig) {
        return PersonalScoringApiFp(this.configuration).apiPersonalscoringAddpagecustomlistPost(identityToken, listName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {string} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalScoringApi
     */
    public apiPersonalscoringDeletepagecustomlistPost(identityToken: string, id?: string, options?: AxiosRequestConfig) {
        return PersonalScoringApiFp(this.configuration).apiPersonalscoringDeletepagecustomlistPost(identityToken, id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalScoringApi
     */
    public apiPersonalscoringPagecustomlistesPost(identityToken: string, options?: AxiosRequestConfig) {
        return PersonalScoringApiFp(this.configuration).apiPersonalscoringPagecustomlistesPost(identityToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {string} [id] 
     * @param {string} [newListName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalScoringApi
     */
    public apiPersonalscoringRenamepagecustomlistPost(identityToken: string, id?: string, newListName?: string, options?: AxiosRequestConfig) {
        return PersonalScoringApiFp(this.configuration).apiPersonalscoringRenamepagecustomlistPost(identityToken, id, newListName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {SaveRequest} [saveRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalScoringApi
     */
    public apiPersonalscoringSaveaspagecustomlistPost(identityToken: string, saveRequest?: SaveRequest, options?: AxiosRequestConfig) {
        return PersonalScoringApiFp(this.configuration).apiPersonalscoringSaveaspagecustomlistPost(identityToken, saveRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalScoringApi
     */
    public apiPersonalscoringScorefieldsPost(identityToken: string, options?: AxiosRequestConfig) {
        return PersonalScoringApiFp(this.configuration).apiPersonalscoringScorefieldsPost(identityToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {ScoringDataRequest} [scoringDataRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalScoringApi
     */
    public apiPersonalscoringScoringdataPost(identityToken: string, scoringDataRequest?: ScoringDataRequest, options?: AxiosRequestConfig) {
        return PersonalScoringApiFp(this.configuration).apiPersonalscoringScoringdataPost(identityToken, scoringDataRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalScoringApi
     */
    public apiPersonalscoringSystemfiltersPost(identityToken: string, options?: AxiosRequestConfig) {
        return PersonalScoringApiFp(this.configuration).apiPersonalscoringSystemfiltersPost(identityToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {UpdateRequest} [updateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalScoringApi
     */
    public apiPersonalscoringUpdatepagecustomlistPost(identityToken: string, updateRequest?: UpdateRequest, options?: AxiosRequestConfig) {
        return PersonalScoringApiFp(this.configuration).apiPersonalscoringUpdatepagecustomlistPost(identityToken, updateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



